<script>
export default {
    props: {
        pills: {
            type: Boolean,
            default: false
        },
        contrast: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        headerClasses() {
            let classes = [
                {
                    'nav-tabs': !this.pills,
                    'nav-pills': this.pills
                }
            ]

            if( this.headerAttrs.class !== undefined ) {
                classes.push(this.headerAttrs.class)
            }

            return classes
        }
    },
    created() {
        // contrst css theme
        require('./css/contrast.css')
    }
}
</script>
